import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import ReadXmlForm from '../forms/read-xml-form';
import { xmlReadValidationSchema } from '../schema/xml.js';

export default function ReadXmlNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Read XML Node Details',
        altText: 'Read XML Node',
        defaultLabel: 'Read XML Node',
      }}
    >
      <CommonNode FormComponent={ReadXmlForm} schemaResolver={xmlReadValidationSchema} />
    </NodeProvider>
  );
}
